import DellIp from "./DelIp";

export default DellIp;